import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { KPIBand } from "./components/KPIBand";
import { RCMServices } from "./components/RCMServices";
import { Credentialing } from "./components/Credentialing";
import { ProviderLicensing } from "./components/ProviderLicensing";
import { Bookkeeping } from "./components/Bookkeeping";
import { EHRShowcase } from "./components/EHRShowcase";
import { Compliance } from "./components/Compliance";
import { ConsultationForm } from "./components/ConsultationForm";
import { Footer } from "./components/Footer";
import { PrivacyPolicy } from "./components/PrivacyPolicy";

const Home = () => (
  <div data-testid="home-page">
    <Header />
    <main>
      <Hero />
      <KPIBand />
      <RCMServices />
      <Credentialing />
      <ProviderLicensing />
      <Bookkeeping />
      <EHRShowcase />
      <Compliance />
      <ConsultationForm />
    </main>
    <Footer />
    <Toaster position="top-right" richColors />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
